<template>
  <div>
    <!-- Single Select Answers -->
    <v-row v-if="questionType == 'SINGLE_CHOICE'">
      <v-col>
        <div class="text-body-1 mb-2">
          Options <span class="required">*</span>
          <span class="font-italic grey--text"
            >(Supported image types: .jpeg/.jpg, .png, .bmp 2;
            Max size - 5MB)
          </span>
        </div>
        <v-radio-group
          v-model="singleSelectCorrectAnswer"
          :rules="[(v) => !!v || 'Please select one']"
        >
          <div
            v-for="(option, index) in options"
            :key="index"
            class="d-flex align-center my-2"
          >
            <v-list-item
              :class="
                singleSelectCorrectAnswer == option.optionKey
                  ? 'lightGreen rounded-xl'
                  : 'grey lighten-4 rounded-xl'
              "
              min-height="72"
              class="flex-grow-1"
            >
              <v-list-item-avatar>
                <v-radio :value="option.optionKey"></v-radio>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle
                  v-if="
                    option.optionValue.startsWith('https://') ||
                    option.optionValue.startsWith('http://') ||
                    option.optionValue.startsWith('blob:')
                  "
                >
                  <span class="d-flex align-start"
                    ><img
                      :src="option.optionValue"
                      alt=""
                      width="auto"
                      height="150"
                      class="img"
                    />
                    <v-btn icon class="ml-1"
                      ><v-icon @click="restorePrevValue(index)"
                        >mdi-close</v-icon
                      ></v-btn
                    ></span
                  >
                </v-list-item-subtitle>
                <v-list-item-title v-else class="align-center">
                  <div v-html="option.optionValue"></div>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-row align="center" class="overflow-hidden">
                  <v-btn
                    class="options-btn"
                    v-if="
                      !option.optionValue.startsWith('https://') ||
                      !option.optionValue.startsWith('http://') ||
                      !option.optionValue.startsWith('blob:')
                    "
                    icon
                    @click="editOption(index)"
                  >
                    <v-icon class="options-icon" large>mdi-format-textbox</v-icon>
                  </v-btn>
                  <v-btn
                    class="px-0 options-btn"
                    text
                    color="blue"
                    @click="editedOptionIndex = index"
                  >
                    <input
                      class="options-attach-img"
                      type="file"
                      name="image"
                      accept="image/*"
                      @change="onChange"
                    />
                    <img :width="24" :src="uploadImageIcon" />
                  </v-btn>
                </v-row>
              </v-list-item-action>
            </v-list-item>
            <div class="d-flex align-center ml-3">
              <div v-if="markingType === 'Likert Marking'" class="d-flex flex-column likert-score-wrapper mr-2">
                <span class="likert-score-label">Option Score <span class="required">*</span></span>
                <div class="likert-score-control">
                  <span class="likert-score-value">{{ option.optionScore || 0 }}</span>
                  <div class="d-flex flex-column likert-score-arrows">
                    <v-btn icon x-small :disabled="(option.optionScore || 0) >= 10" @click="incrementOptionScore(index)">
                      <v-icon x-small>mdi-chevron-up</v-icon>
                    </v-btn>
                    <v-btn icon x-small :disabled="(option.optionScore || 0) === 0" @click="decrementOptionScore(index)">
                      <v-icon x-small>mdi-chevron-down</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
              <v-btn icon @click="removeOption(index)">
                <img :width="24" :height="24" :src="deleteOptionIcon" alt="Delete option" />
              </v-btn>
            </div>
          </div>
        </v-radio-group>
      </v-col>
    </v-row>

    <!-- Multi Select Answers -->
    <v-row v-else-if="questionType == 'MULTIPLE_CHOICE'">
      <v-col cols="12" sm="12" md="12" class="overflow-hidden">
        <div class="text-body-1 mb-2">
          Options <span class="required">*</span>
          <span class="font-italic grey--text"
            >(Guidelines for image in options: 1. File type -
            .jpeg/.jpg, .png, .bmp 2. File size - 5MB)
          </span>
        </div>

        <div
          v-for="(option, index) in options"
          :key="index"
          class="d-flex align-center my-2"
        >
          <v-list-item
            :class="
              selectedAnswersForMultitpleTypeQuestions.includes(option.optionKey)
                ? 'lightGreen rounded-xl'
                : 'grey lighten-4 rounded-xl'
            "
            min-height="72"
            class="flex-grow-1"
          >
            <v-list-item-avatar>
              <v-checkbox
                v-model="selectedAnswersForMultitpleTypeQuestions"
                :value="option.optionKey"
              ></v-checkbox>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-subtitle
                v-if="
                  option.optionValue.startsWith('https://') ||
                  option.optionValue.startsWith('http://') ||
                  option.optionValue.startsWith('blob:')
                "
              >
                <span class="d-flex align-start"
                  ><img
                    :src="option.optionValue"
                    alt=""
                    width="auto"
                    height="150"
                    class="img"
                  />
                  <v-btn icon class="ml-1"
                    ><v-icon @click="restorePrevValue(index)"
                      >mdi-close</v-icon
                    ></v-btn
                  ></span
                >
              </v-list-item-subtitle>
              <v-list-item-title v-else class="align-center">
                <div v-html="option.optionValue"></div>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-row align="center">
                <v-btn
                  v-if="
                    !option.optionValue.startsWith('https://') ||
                    !option.optionValue.startsWith('http://') ||
                    !option.optionValue.startsWith('blob:')
                  "
                  icon
                  @click="editOption(index)"
                >
                  <v-icon large class="pa-2 options-icon">mdi-format-textbox</v-icon>
                </v-btn>
                <v-btn
                  class="px-0"
                  text
                  color="blue"
                  @click="editedOptionIndex = index"
                >
                  <input
                    class="options-attach-img"
                    type="file"
                    name="image"
                    accept="image/*"
                    @change="onChange"
                  />
                  <img :width="24" :src="uploadImageIcon" />
                </v-btn>
              </v-row>
            </v-list-item-action>
          </v-list-item>
          <div class="d-flex align-center ml-3">
            <div v-if="markingType === 'Likert Marking'" class="d-flex flex-column likert-score-wrapper mr-2">
              <span class="likert-score-label">Option Score <span class="required">*</span></span>
              <div class="likert-score-control">
                <span class="likert-score-value">{{ option.optionScore || 0 }}</span>
                <div class="d-flex flex-column likert-score-arrows">
                  <v-btn icon x-small :disabled="(option.optionScore || 0) >= 10" @click="incrementOptionScore(index)">
                    <v-icon x-small>mdi-chevron-up</v-icon>
                  </v-btn>
                  <v-btn icon x-small :disabled="(option.optionScore || 0) === 0" @click="decrementOptionScore(index)">
                    <v-icon x-small>mdi-chevron-down</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
            <v-btn icon @click="removeOption(index)">
              <img :width="24" :height="24" :src="deleteOptionIcon" alt="Delete option" />
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row
      v-if="questionType == 'SINGLE_CHOICE' || questionType == 'MULTIPLE_CHOICE'"
      justify="start"
      align="center"
      class="px-2 blue--text"
      @click="addOption"
    >
      <v-icon :disabled="options.length > 4" large
        >mdi-plus-circle-outline</v-icon
      >
      <v-btn
        :disabled="options.length > 4"
        class="pl-0"
        text
        x-large
        color="blue"
        >Add Options</v-btn
      >
    </v-row>

    <!-- Fill in the blanks -->
    <v-row v-if="questionType == 'FILL_IN_THE_BLANKS'">
      <v-col class="py-0">
        <div class="text-body-1 my-2"></div>
        <v-textarea
          :rules="[(v) => !!v || 'Correct Answer field is required']"
          required
          outlined
          class="rounded-xl"
          v-model="correctAnswer"
        >
          <template v-slot:label>
            Correct Answer<span class="required"> *</span>
          </template>
        </v-textarea>
      </v-col>
    </v-row>

    <!-- True False -->
    <v-row v-if="questionType == 'TRUE_FALSE'">
      <v-col>
        <div class="text-body-1 mb-2">Options*</div>
        <v-radio-group
          v-model="trueFalseCorrectAnswer"
          :rules="[(v) => !!v || 'Please select one']"
        >
          <v-list-item
            :class="
              trueFalseCorrectAnswer == option.optionKey
                ? 'lightGreen rounded-xl my-2'
                : 'grey lighten-4  rounded-xl my-2'
            "
            min-height="72"
            v-for="(option, index) in [
              { optionKey: 'A', optionValue: 'TRUE' },
              { optionKey: 'B', optionValue: 'FALSE' },
            ]"
            :key="index"
          >
            <v-list-item-avatar>
              <v-radio :value="option.optionKey"></v-radio>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ option.optionValue }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-radio-group>
      </v-col>
    </v-row>

    <!-- Match the Following -->
    <div class="text-body-1 my-4" v-if="questionType == 'MATCH_THE_FOLLOWING'">
      Options <span class="required">*</span>
      <span class="font-italic grey--text"
        >(Guidelines for image in options: 1. File type -
        .jpeg/.jpg, .png, .bmp 2. File size - 5MB)
      </span>
    </div>
    <v-row v-if="questionType == 'MATCH_THE_FOLLOWING'">
      <v-col cols="6" sm="12" md="6" class="overflow-hidden">
        <div class="text-body-1 mb-2">Match the Items*</div>
        <v-list-item
          class="grey lighten-4 rounded-xl my-2"
          min-height="72"
          v-for="(option, index) in options"
          :key="index"
        >
          <v-list-item-content>
            <v-list-item-subtitle
              v-if="
                option.optionValue.startsWith('https://') ||
                option.optionValue.startsWith('http://') ||
                option.optionValue.startsWith('blob:')
              "
            >
              <span class="d-flex align-start"
                ><img
                  :src="option.optionValue"
                  alt=""
                  width="auto"
                  height="150"
                  class="img"
                />
                <v-btn icon class="ml-1"
                  ><v-icon @click="restorePrevValue(index)"
                    >mdi-close</v-icon
                  ></v-btn
                ></span
              >
            </v-list-item-subtitle>
            <v-list-item-title v-else class="align-center">
              <div v-html="option.optionValue"></div>
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-row align="center">
              <v-btn
                v-if="
                  !option.optionValue.startsWith('https://') ||
                  !option.optionValue.startsWith('http://') ||
                  !option.optionValue.startsWith('blob:')
                "
                icon
                @click="editOption(index)"
              >
                <v-icon large class="pa-2">mdi-format-textbox </v-icon>
              </v-btn>
              <v-btn
                class="px-0"
                text
                color="blue"
                @click="editedOptionIndex = index"
              >
                <input
                  class="options-attach-img"
                  type="file"
                  name="image"
                  accept="image/*"
                  @change="onChange"
                />
                <img :width="24" :src="uploadImageIcon" />
              </v-btn>
              <v-btn icon @click="removeOption(index)">
                <img :width="24" :height="24" :src="deleteOptionIcon" alt="Delete option" />
              </v-btn>
            </v-row>
          </v-list-item-action>
        </v-list-item>
      </v-col>
      <v-col cols="6" sm="12" md="6" class="overflow-hidden">
        <div class="text-body-1 mb-2">Correct Answers*</div>
        <v-list-item
          class="grey lighten-4 rounded-xl my-2"
          min-height="72"
          v-for="(ans, index) in answers"
          :key="index"
        >
          <v-list-item-content>
            <v-list-item-subtitle
              v-if="
                ans.optionValue.startsWith('https://') ||
                ans.optionValue.startsWith('http://') ||
                ans.optionValue.startsWith('blob:')
              "
            >
              <span class="d-flex align-start"
                ><img
                  :src="ans.optionValue"
                  alt=""
                  width="auto"
                  height="150"
                  class="img"
                />
                <v-btn icon class="ml-1"
                  ><v-icon @click="restorePrevAnswerValue(index)"
                    >mdi-close</v-icon
                  ></v-btn
                ></span
              >
            </v-list-item-subtitle>
            <v-list-item-title v-else class="align-center">
              <div v-html="ans.optionValue"></div>
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-row align="center">
              <v-btn
                v-if="
                  !ans.optionValue.startsWith('https://') ||
                  !ans.optionValue.startsWith('http://') ||
                  !ans.optionValue.startsWith('blob:')
                "
                icon
                @click="editAnswer(index)"
              >
                <v-icon large class="pa-2">mdi-format-textbox </v-icon>
              </v-btn>
              <v-btn
                class="px-0"
                text
                color="blue"
                @click="editedAnswerIndex = index"
              >
                <input
                  class="options-attach-img"
                  type="file"
                  name="image"
                  accept="image/*"
                  @change="onChangeAnswer"
                />
                <img :width="24" :src="uploadImageIcon" />
              </v-btn>
              <v-btn icon @click="removeAnswer(index)">
                <img :width="24" :height="24" :src="deleteOptionIcon" alt="Delete option" />
              </v-btn>
            </v-row>
          </v-list-item-action>
        </v-list-item>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="py-0">
        <div class="text-body-1 my-2"></div>
        <v-textarea
          required
          outlined
          class="rounded-xl"
          label="Answer Explaination"
          v-model="answerExplanation"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <div class="text-body-1 my-2"></div>
        <v-textarea
          outlined
          class="rounded-xl textarea"
          label="Answer Hint"
          required
          v-model="hint"
        ></v-textarea>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="py-0">
        <div class="text-body-1 my-2"></div>
        <v-text-field
          outlined
          class="rounded-xl"
          label="Strand"
          type="text"
          v-model="strand"
        ></v-text-field>
      </v-col>
      <v-col class="py-0">
        <div class="text-body-1 my-2"></div>
        <v-text-field
          outlined
          class="rounded-xl"
          label="Sub Strand"
          type="text"
          v-model="subStrand"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <v-text-field
          outlined
          class="rounded-xl"
          label="Topic"
          type="text"
          v-model="topic"
        ></v-text-field>
      </v-col>
      <v-col class="py-0">
        <v-autocomplete
          v-model="selectedLOs"
          clearable
          deletable-chips
          label="Select or Search LO's"
          outlined
          class="rounded-xl"
          height="50px"
          chips
          :items="loData"
          multiple
          item-text="name"
          item-value="io_code"
          attach
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <div class="text-body-1 my-2"></div>
        <v-autocomplete
          label="Case Sensitive"
          :items="['Yes', 'No']"
          outlined
          class="rounded-xl"
          v-model="isCaseSensitive"
          attach
        ></v-autocomplete>
      </v-col>
      <v-col class="py-0">
        <div class="text-body-1 my-2"></div>
        <v-autocomplete
          label="Bloom's Taxonomy Level"
          :items="bloomsTaxonomyLevel"
          outlined
          class="rounded-xl"
          v-model="bloomsTaxonomy"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col class="py-0" cols="6" sm="6" md="6">
        <div class="text-body-1 my-2"></div>
        <v-autocomplete
          label="Difficulty Level"
          :items="difficultyLevels"
          outlined
          class="rounded-xl"
          v-model="difficultyLevel"
        ></v-autocomplete>
      </v-col>
      <v-col class="py-0">
        <div class="text-body-1 my-2"></div>
        <v-autocomplete
          label="Complexity Level"
          :items="complexityLevels"
          outlined
          class="rounded-xl"
          v-model="complexityLevel"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0" cols="6" sm="6" md="6">
        <div class="text-body-1 my-2"></div>
        <v-autocomplete
          label="Proficiency Level"
          :items="['A1', 'A2', 'B1', 'B2', 'C1', 'C2']"
          outlined
          class="rounded-xl"
          v-model="proficiencyLevel"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <!-- Edit Option Dialog -->
    <v-dialog max-width="887px" v-model="optionTextFieldDialog" center>
      <v-card>
        <v-card-title class="gray-02 mb-8">Edit Option</v-card-title>
        <v-card-text>
          <ckeditor
            :config="editorConfigForOption"
            v-model="editedCkeditorValue"
            class="m-ckeditor"
            @ready="onEditorReady"
          ></ckeditor>
          <p v-if="!isEditedValueValid" class="error-message red--text">
            Please enter a valid value (maximum 200 characters).
          </p>
        </v-card-text>
        <v-card-actions class="px-6 pb-6">
          <v-spacer></v-spacer>
          <v-btn
            depressed
            rounded
            class="btn outline-btn font-weight-medium pa-4"
            @click="optionTextFieldDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            depressed
            rounded
            @click="saveEditedValue"
            class="btn primary-btn pa-4"
            :disabled="!isEditedValueValid"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Answer Dialog -->
    <v-dialog max-width="887px" v-model="answerTextFieldDialog" center>
      <v-card>
        <v-card-title class="gray-02 mb-8">Edit Option</v-card-title>
        <v-card-text>
          <ckeditor
            :config="editorConfigForOption"
            v-model="editedCkeditorValue"
            class="m-ckeditor"
            @ready="onEditorReady"
          ></ckeditor>
          <p v-if="!isEditedValueValid" class="error-message red--text">
            Please enter a valid value (maximum 200 characters).
          </p>
        </v-card-text>
        <v-card-actions class="px-6 pb-6">
          <v-spacer></v-spacer>
          <v-btn
            depressed
            rounded
            class="btn outline-btn font-weight-medium pa-4"
            @click="answerTextFieldDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            depressed
            rounded
            @click="saveEditedAnswer"
            class="btn primary-btn pa-4"
            :disabled="!isEditedValueValid"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- File uploading status -->
    <v-dialog v-model="uploadingDialog" max-width="366px" persistent>
      <v-card>
        <v-container fluid class="pa-8">
          <v-card-text class="text-center d-flex flex-column align-center">
            <v-icon
              v-if="uploadingMsg != 'File Uploading...'"
              color="success"
              size="96"
              >mdi-check-circle-outline</v-icon
            >
            <p class="text-h5 py-4">{{ uploadingMsg }}</p>
            <v-progress-circular
              :size="50"
              color="blue"
              indeterminate
              v-if="uploadingMsg == 'File Uploading...'"
            ></v-progress-circular>
            <v-btn
              class="btn primary-btn"
              large
              width="157px"
              rounded
              @click="uploadingDialog = false"
              v-if="uploadingMsg != 'File Uploading...'"
              >Ok</v-btn
            >
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>

    <p v-if="uploadError" class="error-message red--text">{{ uploadError }}</p>
  </div>
</template>

<script>
import { storage } from "../firebase";
import { getDownloadURL, ref, uploadBytes } from "@firebase/storage";

const defaultOptions = [
  { optionKey: "A", optionValue: "Option 1", optionScore: 0 },
  { optionKey: "B", optionValue: "Option 2", optionScore: 0 },
  { optionKey: "C", optionValue: "Option 3", optionScore: 0 },
  { optionKey: "D", optionValue: "Option 4", optionScore: 0 },
];
const defaultAnswers = [
  { optionKey: "A", optionValue: "Answer 1" },
  { optionKey: "B", optionValue: "Answer 2" },
  { optionKey: "C", optionValue: "Answer 3" },
  { optionKey: "D", optionValue: "Answer 4" },
];

export default {
  name: "PassageSubQuestionAnswer",
  props: {
    questionType: { type: String, required: true },
    markingType: { type: String, required: true },
    value: { type: Object, default: null },
    loData: { type: Array, default: () => [] },
  },
  data() {
    const isMtf = this.questionType === 'MATCH_THE_FOLLOWING';
    const mtfPairs = isMtf && this.value?.correctAnswer ? this.parseMtfPairs(this.value.correctAnswer) : null;
    return {
      options: mtfPairs
        ? mtfPairs.options
        : JSON.parse(JSON.stringify(!isMtf && this.value?.questionOptions?.length ? this.value.questionOptions : defaultOptions)),
      answers: mtfPairs ? mtfPairs.answers : JSON.parse(JSON.stringify(defaultAnswers)),
      singleSelectCorrectAnswer: this.questionType === 'SINGLE_CHOICE' ? (this.value?.correctAnswer || null) : null,
      selectedAnswersForMultitpleTypeQuestions: this.questionType === 'MULTIPLE_CHOICE' ? (this.value?.correctAnswer ? this.value.correctAnswer.split(",") : []) : [],
      correctAnswer: this.questionType === 'FILL_IN_THE_BLANKS' ? (this.value?.correctAnswer || "") : "",
      trueFalseCorrectAnswer: this.questionType === 'TRUE_FALSE' ? (this.value?.correctAnswer || null) : null,
      hint: this.value?.hint || "",
      answerExplanation: this.value?.answerExplanation || "",
      strand: this.value?.strand || "",
      subStrand: this.value?.subStrand || "",
      topic: this.value?.topic || "",
      selectedLOs: this.value?.selectedLOs || [],
      isCaseSensitive: this.value?.isCaseSensitive || "No",
      bloomsTaxonomy: this.value?.bloomsTaxonomy || "",
      complexityLevel: this.value?.complexityLevel || "",
      proficiencyLevel: this.value?.proficiencyLevel || "",
      difficultyLevel: this.value?.difficultyLevel || "",
      complexityLevels: ["P1", "P2", "P3", "P4", "P5"],
      bloomsTaxonomyLevel: ["REMEMBER", "UNDERSTAND", "APPLY", "ANALYSE", "ANALYZE", "EVALUATE", "CREATE"],
      difficultyLevels: ["EASY", "MEDIUM", "HARD"],
      editedOptionIndex: null,
      editedAnswerIndex: null,
      selectedFile: null,
      tempOptions: new Map(),
      tempAnswers: new Map(),
      optionTextFieldDialog: false,
      answerTextFieldDialog: false,
      editedCkeditorValue: "",
      uploadingDialog: false,
      uploadingMsg: "File Uploading...",
      uploadError: "",
      editorConfigForOption: {
        extraPlugins: "ckeditor_wiris",
      },
      uploadImageIcon: require("@/assets/uploadImage.svg"),
      deleteOptionIcon: require("@/assets/delete-noir.svg"),
    };
  },
  computed: {
    isEditedValueValid() {
      return this.getTextWithoutHTMLTags(this.editedCkeditorValue).length <= 200;
    },
    isAnswerValid() {
      if (this.questionType === 'SINGLE_CHOICE') return !!this.singleSelectCorrectAnswer;
      if (this.questionType === 'TRUE_FALSE') return !!this.trueFalseCorrectAnswer;
      if (this.questionType === 'FILL_IN_THE_BLANKS') return !!this.correctAnswer;
      if (this.questionType === 'MULTIPLE_CHOICE') return this.selectedAnswersForMultitpleTypeQuestions?.length > 0;
      return true;
    },
    assembledPayload() {
      return {
        questionOptions: this.getOptions(),
        correctAnswer: this.getCorrectAnswer(),
        mtfOptions: this.questionType === 'MATCH_THE_FOLLOWING' ? this.prepareOptions(this.getOptions()) : null,
        hint: this.hint,
        answerExplanation: this.answerExplanation,
        strand: this.strand,
        subStrand: this.subStrand,
        topic: this.topic,
        selectedLOs: this.selectedLOs,
        isCaseSensitive: this.isCaseSensitive,
        bloomsTaxonomy: this.bloomsTaxonomy,
        complexityLevel: this.complexityLevel,
        proficiencyLevel: this.proficiencyLevel,
        difficultyLevel: this.difficultyLevel,
        isValid: this.isAnswerValid,
      };
    },
  },
  watch: {
    markingType() {
      // Mirrors handleMarkingTypeChange() in QuestionBankView.vue — reset per-option
      // Likert scores when marking type changes. correctAnswerScore stays parent-owned.
      this.options = this.options.map(({ optionScore, ...rest }) => ({
        ...rest,
        optionScore: 0,
      }));
    },
    assembledPayload: {
      handler(payload) {
        this.$emit("input", payload);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getTextWithoutHTMLTags(text) {
      return (text || "").replace(/<[^>]*>?/gm, "");
    },
    getAlphabet(num) {
      return String.fromCharCode(65 + num);
    },
    parseMtfPairs(correctAnswer) {
      const pairs = correctAnswer.split(", ").map((item) => {
        const [key, value] = item.split(":");
        return { key: (key || "").trim(), value: (value || "").trim() };
      });
      const options = [];
      const answers = [];
      pairs.forEach((pair, index) => {
        const optionKey = this.getAlphabet(index);
        options.push({ optionKey, optionValue: pair.key });
        answers.push({ optionKey, optionValue: pair.value });
      });
      return { options, answers };
    },
    addOption() {
      if (this.options.length > 4) return;
      this.options.push({
        optionKey: this.getAlphabet(this.options.length),
        optionValue: "Option " + (this.options.length + 1),
        optionScore: 0,
      });
    },
    removeOption(index) {
      this.options.splice(index, 1);
    },
    removeAnswer(index) {
      this.answers.splice(index, 1);
    },
    restorePrevValue(index) {
      this.options[index].optionValue = this.tempOptions.get(index);
    },
    restorePrevAnswerValue(index) {
      this.answers[index].optionValue = this.tempAnswers.get(index);
    },
    editOption(index) {
      this.editedOptionIndex = index;
      this.optionTextFieldDialog = true;
      this.editedCkeditorValue = "";
      setTimeout(() => {
        this.editedCkeditorValue = this.options[this.editedOptionIndex].optionValue;
      }, 1000);
    },
    editAnswer(index) {
      this.editedAnswerIndex = index;
      this.answerTextFieldDialog = true;
      this.editedCkeditorValue = "";
      setTimeout(() => {
        this.editedCkeditorValue = this.answers[this.editedAnswerIndex].optionValue;
      }, 1000);
    },
    saveEditedValue() {
      this.options[this.editedOptionIndex].optionValue = this.editedCkeditorValue;
      this.optionTextFieldDialog = false;
    },
    saveEditedAnswer() {
      this.answers[this.editedAnswerIndex].optionValue = this.editedCkeditorValue;
      this.answerTextFieldDialog = false;
    },
    incrementOptionScore(index) {
      const score = this.options[index].optionScore || 0;
      if (score < 10) this.$set(this.options[index], 'optionScore', score + 1);
    },
    decrementOptionScore(index) {
      const score = this.options[index].optionScore || 0;
      if (score > 0) this.$set(this.options[index], 'optionScore', score - 1);
    },
    onEditorReady(editor) {
      editor.on("afterCommandExec", function (event) {
        var commandName = event.data.name;
        if (
          [
            "ckeditor_wiris_openFormulaEditor",
            "ckeditor_wiris_openFormulaEditorChemistry",
          ].includes(commandName)
        ) {
          setTimeout(() => {
            const wiris_license_overlays = document.querySelectorAll(".wrs_tickContainer");
            wiris_license_overlays.forEach((element) => {
              element.remove();
            });
          }, 2000);
        }
      });
    },
    onChange(e) {
      this.tempOptions.set(this.editedOptionIndex, this.options[this.editedOptionIndex].optionValue);
      this.uploadFile(e, (url) => {
        this.options[this.editedOptionIndex].optionValue = url;
      });
    },
    onChangeAnswer(e) {
      this.tempAnswers.set(this.editedAnswerIndex, this.answers[this.editedAnswerIndex].optionValue);
      this.uploadFile(e, (url) => {
        this.answers[this.editedAnswerIndex].optionValue = url;
      });
    },
    uploadFile(e, onUploaded) {
      const selectedFile = e.target.files[0];
      if (!selectedFile) return;
      if (selectedFile.type.startsWith('audio/') && selectedFile.size > 100 * 1024 * 1024) {
        e.target.value = '';
        this.uploadError = "The audio file exceeds the maximum limit of 100 MB. Please upload a smaller file.";
        return;
      }
      this.uploadError = "";
      this.uploadingMsg = "File Uploading...";
      this.uploadingDialog = true;
      const storageRef = ref(storage, "/question_bank/" + selectedFile.name + new Date().getTime());
      uploadBytes(storageRef, selectedFile).then((snapshot) => {
        getDownloadURL(snapshot.ref).then((url) => {
          onUploaded(url);
          this.uploadingMsg = "File Uploaded";
        });
      });
    },
    getCorrectAnswer() {
      switch (this.questionType) {
        case "SINGLE_CHOICE":
          return this.singleSelectCorrectAnswer;
        case "MULTIPLE_CHOICE":
          return this.selectedAnswersForMultitpleTypeQuestions.join(",");
        case "FILL_IN_THE_BLANKS":
          return this.correctAnswer;
        case "TRUE_FALSE":
          return this.trueFalseCorrectAnswer;
        case "MATCH_THE_FOLLOWING":
          return this.getOptions();
        default:
          return null;
      }
    },
    getOptions() {
      switch (this.questionType) {
        case "SINGLE_CHOICE":
        case "MULTIPLE_CHOICE":
          return this.options;
        case "FILL_IN_THE_BLANKS":
          return [];
        case "TRUE_FALSE":
          return [
            { optionKey: "A", optionValue: "TRUE" },
            { optionKey: "B", optionValue: "FALSE" },
          ];
        case "MATCH_THE_FOLLOWING": {
          const result = this.options
            .map((option) => {
              const answer = this.answers.find((a) => a.optionKey === option.optionKey);
              const city = option.optionValue.replace(/<\/?p>/g, "").trim();
              const dish = (answer?.optionValue || "").replace(/<\/?p>/g, "").trim();
              return `${city}:${dish}`;
            })
            .join(", ");
          return result;
        }
        default:
          return [];
      }
    },
    prepareOptions(correctAnswer) {
      if (!correctAnswer) return [];
      const mtfOptions = [];
      const entries = correctAnswer.split(", ");
      const countries = entries.map((entry) => entry.split(":")[0]);
      const cities = entries.map((entry) => entry.split(":")[1]);
      const shuffledCities = cities.sort(() => Math.random() - 0.5);
      countries.forEach((country, index) => {
        mtfOptions.push({ key: country, value: shuffledCities[index] });
      });
      return mtfOptions;
    },
  },
};
</script>

<style scoped>
.likert-score-wrapper {
  gap: 4px;
}

.likert-score-label {
  font-size: 12px;
  font-weight: 500;
  color: #4a4a4a;
  white-space: nowrap;
}

.likert-score-control {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #d9dee8;
  border-radius: 8px;
  padding: 2px 6px;
  min-width: 80px;
}

.likert-score-value {
  font-size: 14px;
  font-weight: 600;
  color: #4a4a4a;
  flex: 1;
}

.likert-score-arrows .v-btn {
  width: 16px !important;
  height: 16px !important;
}

.likert-score-arrows .v-icon {
  font-size: 14px !important;
}

.options-icon {
  font-size: 24px !important;
}

.options-btn {
  height: 24px !important;
  width: 24px !important;
}

.options-attach-img {
  width: 64px;
}
</style>
